<template>
    <section class="blockElement subscriptionPlanSteps vh-100 overflow-auto space">
        <Header />
        <div class="d-flex justify-content-end padSpace" @click="store.clearMessage" v-if="store.error.msg">
            <button type="button" class="close_btn">
                <vue-feather size="26" type="x"></vue-feather>
            </button>
        </div>
        <div class="container">
            <div class="row pamentCalc align-items-center justify-content-center">
                <div class="col-12 col-md-4" v-if="$route.query.type == 'failure'">
                    <div class="pt-0 text-center genrateMessage">
                        <img height="100" width="100" class="d-block mx-auto mb-5" :src="`${static_vars.imagePath}/assets/images/wrong48.svg`" :alt="$t('test_result.text7')" />
                        <h3 class="my-3 clash">{{$t('test_result.text1')}}</h3>
                        <p class="my-4 mb-md-5 f-18 dark">{{$t('test_result.text2')}}</p>
                        <div class="w-100">
                            <router-link to="/sutaibility" class="grd_btn full_size">{{$t('test_result.text3')}}</router-link>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6" v-if="$route.query.type == 'success'">
                    <div class="pt-0 text-center genrateMessage" v-if="((Object.keys(store.failTest).length && !store.failTest?.success) || (Object.keys(store.questionariesStatus).length && !store.questionariesStatus.canSubmit))">
                        <img height="100" width="100" class="d-block mx-auto mb-5" :src="`${static_vars.imagePath}/assets/images/wrong48.svg`" :alt="$t('test_result.text7')" />
                        <h3 class="my-3 mb-md-5 clash">{{$t('changes.text7') }} {{!(store.questionariesStatus?.canSubmit) ? getRemainingTime(store.questionariesStatus?.expiryValidationDate) : getRemainingTime(store.failTest?.validationExpirationDate)}}.</h3>
                        <div class="w-100">
                            <a :href="`${static_vars.domainURL}dashboard`" class="grd_btn">{{$t('test_result.text5')}}</a>
                        </div>
                    </div>
                    <div class="pt-0 text-center genrateMessage" v-else>
                        <img height="100" width="100" class="d-block mx-auto mb-5" :src="`${static_vars.imagePath}/assets/images/success14789.png`" :alt="$t('test_result.text7')" />
                        <h3 class="my-3 mb-md-5 clash">{{$t('test_result.text4')}}</h3>
                        <!-- <p class="my-4 mb-md-5 f-18">As per your answers and regulations your Available Capital for CopyTrading is <b>xxx</b></p> -->
                        <div class="w-100">
                            <a :href="`${static_vars.domainURL}dashboard`" class="grd_btn me-3">{{$t('test_result.text5')}}</a>
                            <!-- <a :href="`${static_vars.domainURL}dashboard/subscription`" class="grd_btn" v-if="isIntegrateBroker()">{{$t('test_result.text6')}}</a>
                            <router-link to="/subscription-plan" class="grd_btn" v-else-if="!isIntegrateBroker()">{{$t('test_result.text6')}}</router-link> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    import { useMainStore } from "@/store";
    import moment from 'moment'
    export default {
        setup() {
            const store = useMainStore();
            return { store };
        },
        data() {
            return {
                brokerID : []
                // brokerID : [289,305,36,197,41,158,318,31]

            };
        },
        methods:{
            getRemainingTime(date){
                if(date){
                    return moment(date).subtract(new Date().getTimezoneOffset(),'minutes').fromNow();
                }
            },
            isIntegrateBroker(){
                if(this.brokerID.length){
                    return true
                }else{
                    return false
                }
            }
        },
        created(){
            // if(this.$route.query?.type == 'success'){
            //     this.store.getsubscriptionSelectPlan({},false).then((response) =>{
            //         if(response.length){ 
            //             this.brokerID = response.filter( i=>  (i?.status == "FREE_PLAN" || i.type == "FREE_PLAN" ));
            //         }else{
            //             this.brokerID = []
            //         }
            //     })
            // }
        }
    };
</script>
